import React from 'react'
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import ReactHtmlParser from 'react-html-parser';

const OurAwesomeTeam = () => {
    const settings = {
        arrows: false,
        nav: false,
        dots: true,
        infinite: false,
        lazyLoad: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        initialSlide: 0,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    dots: true
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    initialSlide: 0
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    };

    const teamDataObj = [
        {
            id: 1,
            name: 'Ashish Kumar',
            img: "assets/img/team-image/ashish.webp",
            designation: 'Chief Operating Officer (COO)',
            para: "It is great to work for a company that encourages new ideas and talents. At Alobha, It is very satisfying that we are helping",
            spanpara: "people to find jobs, and promoting the new talents to come forward and learn new skills of trending Technologies on Web & Mobile App Development.",
            spanid: "collapseContent",
            hrefc: "#collapseContent",
            aria: "collapseContent",


        }, {
            id: 2,
            name: 'Sandeep Gupta',
            img: "assets/img/team-image/sandeep.webp",
            designation: 'BPM & Project Manager',
            para: "As a Software development company, we are responsible for driving our business.We serve our customers, quality, reliability,",
            spanpara: "durability, vocational value. Alobha Technologies is committed to Serve Better Solution and set a high standard of development",
            spanid: "collapseContent2",
            hrefc: "#collapseContent2",
            aria: "collapseContent2",

        }
    ]
    return (
        <>
            <section className="team-area ptb-80 bg-f9f6f6">
                <div className="container">
                    <div className="section-title">
                        <h2>Our Awesome Team</h2>
                        <div className="bar"></div>
                        <p> We believe in bringing together the professionals having vast
                            experiences, different Skill Sets and passion for providing your
                            business with the best experience.</p>
                    </div>
                </div>
                <Slider {...settings} >
                    {teamDataObj.map((awesocard) => {
                        return <div className="single-team single-team-slider" key={awesocard.id}>
                            <div className="team-image">
                                <img src={awesocard.img} alt="" loading="lazy"/>
                            </div>
                            <div className="team-content">
                                <div className="team-info">
                                    <h3>{awesocard.name}</h3>
                                    <span>{awesocard.designation}</span>
                                </div>
                                <p className="mb-2">{awesocard.para}<span className="collapse" id={awesocard.spanid}>{awesocard.spanpara}</span>
                                </p>
                                <a className="collapsed text-right text-green" data-toggle="collapse" href={awesocard.hrefc} role="button"
                                    aria-expanded="false" aria-controls={awesocard.aria}>
                                    <span className="if-collapsed">See more...</span>
                                    <span className="if-not-collapsed"><b>^</b></span>
                                </a>
                            </div>
                        </div>
                    })}
                </Slider>
            </section>
        </>
    )
}

export default OurAwesomeTeam